module.exports = __webpack_public_path__ + "img/1560920850.7fa89927.jpg";